module.exports = "<div id=\"category-filter\" class=\"aside__filters v13\">\r\n  <div class=\"widget__products widget-aside v13\">\r\n    <h5 class=\"title-primary v13 mt0 text-left text-uppercase mb15\">Líneas de Productos</h5>\r\n    <div class=\"widget-aside__wrapper widget__accordion\">\r\n      <categories-accordion items=\"$ctrl.shCtrl.globalCategoriesMenu[0].hijas\"></categories-accordion>\r\n    </div>\r\n  </div>\r\n</div>\r\n";


/*****************
 ** WEBPACK FOOTER
 ** ./www/components/catalog/categories-filter/categories-slider-filter/templates/categories-slider-filter-t13.view.html
 ** module id = 428
 ** module chunks = 0
 **/